import { AnalyticsProvider } from '@/core/analytics'

import type { AnalyticsData, BuilderPageModel } from '@/models'

import { BLOCK_MAPPER } from '../../blocks/mapper'
import { Metatags } from '../Metatags'
import { Theme } from '../Theme'

type Props = {
  data: BuilderPageModel['data']
  url: string
}

const CustomBuilderComponent = ({ data, url }: Props) => {
  const analytics = data?.analytics as AnalyticsData
  return (
    <Theme data={data}>
      <Metatags data={data} />
      <AnalyticsProvider event={{ ...analytics, url, position: 'meio' }}>
        {data?.blocks?.map((block) => {
          if (!block || !block.component) return null
          const componentName = block.component.name as keyof typeof BLOCK_MAPPER
          const Component = BLOCK_MAPPER[componentName] || null
          if (!Component) return null
          const props = block.component.options || {}
          return <Component key={block.id} {...props} />
        })}
      </AnalyticsProvider>
    </Theme>
  )
}
export default CustomBuilderComponent
